export interface FileWithMetadata extends File {
  _metadata?: {
    hasBase64?: boolean
    blobName?: string
    base64?: string
  }
}

export function createFileFromBase64(
  base64: string,
  fileName: string,
  mimeType: string = 'application/pdf',
): FileWithMetadata {
  const base64Data = base64.includes(',') ? base64.split(',')[1] : base64

  const binaryString = atob(base64Data)
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  const blob = new Blob([bytes], { type: mimeType })
  const file = new File([blob], fileName, {
    type: mimeType,
  }) as FileWithMetadata

  file._metadata = {
    hasBase64: true,
    base64: base64Data,
  }

  return file
}

export function createFileFromBlobName(
  blobName: string,
  mimeType: string = 'application/pdf',
): FileWithMetadata {
  const emptyBlob = new Blob([], { type: mimeType })
  const file = new File([emptyBlob], blobName, {
    type: mimeType,
  }) as FileWithMetadata

  file._metadata = {
    hasBase64: false,
    blobName: blobName,
  }

  return file
}

export function hasBase64Data(file: File | FileWithMetadata | null): boolean {
  if (!file) return false
  const fileWithMeta = file as FileWithMetadata
  return fileWithMeta._metadata?.hasBase64 === true
}

export function isBlobNameOnly(file: File | FileWithMetadata | null): boolean {
  if (!file) return false
  const fileWithMeta = file as FileWithMetadata
  return (
    fileWithMeta._metadata?.hasBase64 === false &&
    !!fileWithMeta._metadata?.blobName
  )
}

export function getBlobName(
  file: File | FileWithMetadata | null,
): string | undefined {
  if (!file) return undefined
  const fileWithMeta = file as FileWithMetadata
  return fileWithMeta._metadata?.blobName
}

export function getBase64Data(
  file: File | FileWithMetadata | null,
): string | undefined {
  if (!file) return undefined
  const fileWithMeta = file as FileWithMetadata
  return fileWithMeta._metadata?.base64
}

export function preserveFileMetadata(
  sourceFile: FileWithMetadata,
  newFile: File,
): FileWithMetadata {
  const fileWithMeta = newFile as FileWithMetadata
  fileWithMeta._metadata = { ...sourceFile._metadata }
  return fileWithMeta
}
